import axios from 'axios'
import Utils from '@/common/Utils'

const url = process.env.VUE_APP_BLUENV === 'development' ? '/api' : '/api'

const headers = { 'Content-Type': 'application/json' }

export default class MenuService {
    static async getAll (params) {
        return new Promise(async (resolve, reject) => {
            try {
                headers['Authorization'] = await Utils.setLocalToken()
                let { data } = await axios.get(`${url}/menu`, { headers, params })
                resolve(data)
            } catch (error) {
                reject(error)
            }
        })
    }
}
